import { Annotation } from "./Annotation";
import AnnotationsRepository from "./AnnotationsRepository";

export default class AnnotationsService {
  private readonly annotationsRepository: AnnotationsRepository =
    new AnnotationsRepository();

  async postAnnotations(data: Annotation) {
    try {
      return await this.annotationsRepository.postAnnotations(data);
    } catch (error) {
      console.error(error);
    }
  }

  async getAnnotationsBySourceId(
    parameterId: any,
    sourceId: string,
    startDate: string,
    endDate: string
  ) {
    try {
      return await this.annotationsRepository.getAnnotationsBySourceId(
        parameterId,
        sourceId,
        startDate,
        endDate
      );
    } catch (error) {
      console.error(error);
    }
  }
}
